module.exports = "<table class=\"horizontal-table\">\r\n    <tbody>\r\n      <tr *ngFor=\"let row of textCode.data\">\r\n        <td *ngFor=\"let column of row\">\r\n          {{column}}\r\n        </td>\r\n      </tr>\r\n    </tbody>\r\n</table>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/detail-resultat/body/horizontal-table/body-horizontal-table.component.html
// module id = ../../../../../src/app/pages/cerba/pages/detail-resultat/body/horizontal-table/body-horizontal-table.component.html
// module chunks = 0